import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@fairygodboss/ui';
import {
    CountdownBanner,
    AboveTheFold,
    EventBody,
    SpeakerSection,
    Sponsors,
    ParticipatingEmployers,
    BottomRegistrationSection,
    CalendarEvents,
} from './components';
import { EventRegistrationProvider } from './EventRegistrationContext';
import VisibilityPixel from '../../Analytics/VisibilityPixel/VisibilityPixel';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import { ResetStyle } from '../../Community/SingleContent/SharedComponents/ResetStyle';

export const EventLandingPage = ({ event, attendeeCount, upcomingEvents }) => {
    const sponsorIds = event?.sponsors?.map((company) => company.companyId);
    const impressionMetrics = {
        misc_event_count: 1,
        misc_event_type: 'event-view-impression',
        event_id: event?.id,
        company_id: sponsorIds,
    };

    return (
        <EventRegistrationProvider
            event={event}
            attendeeCount={attendeeCount}
            upcomingEvents={upcomingEvents}
        >
            <VisibilityPixel metrics={impressionMetrics} />
            <ResetStyle>
                <ThemeProvider>
                    <CountdownBanner />
                    <AboveTheFold />
                    <EventBody />
                    <SpeakerSection />
                    <Sponsors />
                    <ParticipatingEmployers />
                    <CalendarEvents />
                    <BottomRegistrationSection />
                </ThemeProvider>
            </ResetStyle>
        </EventRegistrationProvider>
    );
};

EventLandingPage.displayName = 'EventLandingPage';

EventLandingPage.propTypes = {
    event: eventPropTypesShape.isRequired,
    attendeeCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    upcomingEvents: PropTypes.arrayOf(eventPropTypesShape),
};

EventLandingPage.defaultProps = {
    attendeeCount: null,
    upcomingEvents: [],
};
